import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface LookupRequest {
  product_code1: string;
  product_code2: string;
}

export interface LabelData {
  product_code1: string;
  product_code2: string;
  description: string;
  processing: string;
  width_inch: number;
  width_cm: number;
  width2_inch: number;
  width2_cm: number;
  weight_gsm: number;
  weight_oz_yd: number;
  is_english: boolean;
}

export interface PrintLabel {
  product_code1: string;
  product_code2: string;
  description: string;
  processing: string;
  width_formatted: string;
  width_cm_fmt: string;
  weight_gsm: string;
  weight_oz_yd: string;
}

export interface PrintResponse {
  labels: PrintLabel[];
  message: string;
}

export interface LookupResponse {
  data?: LabelData | null;
  message?: string;
}

export interface PrintAPIResponse {
  data?: PrintResponse;
}

// ============================================================
// API Client
// ============================================================

export const j30cApi = {
  async lookup(req: LookupRequest): Promise<LookupResponse> {
    const res = await apiClient.post('/api/j30c/lookup', {
      product_code1: req.product_code1.trim(),
      product_code2: req.product_code2.trim(),
    });
    return res.data;
  },

  async print(labelData: LabelData, copies: number): Promise<PrintAPIResponse> {
    const res = await apiClient.post('/api/j30c/print', {
      ...labelData,
      copies,
    });
    return res.data;
  },
};
